import { render, staticRenderFns } from "./RmOrdersConfirmation.vue?vue&type=template&id=1b8e714d&"
import script from "./RmOrdersConfirmation.vue?vue&type=script&lang=js&"
export * from "./RmOrdersConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./RmOrdersConfirmation.vue?vue&type=style&index=0&id=1b8e714d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports